import { AfterContentInit, Component, ContentChildren, Input, OnDestroy, OnInit, QueryList } from '@angular/core';
import { EdlComment } from 'src/app/model/comment.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CommentState } from 'src/app/model/enum/comment-state.enum';
import { ObservationTypes } from 'src/app/model/enum/observation-types.enum';
import { GenericType } from 'src/app/model/base/edl-generic-type.model';
import { PermissionTypes } from 'src/app/model/enum/permission-types.enum';
import { NestedDirective } from 'src/app/directives/nested/component/nested.directive';
import { CommentTags } from '../../enums/comment-tags.enum';
import { FilteredNested } from 'src/app/directives/nested/utility/filtered-nested.util';
import { DEFAULT_HISTORICAL_LABEL } from '../../constants/observation-comments.constants';

@Component({
    selector: 'paetep-display-comment',
    templateUrl: './display-comment.component.html',
    styleUrls: ['./display-comment.component.scss']
})
export class DisplayCommentComponent implements OnInit, OnDestroy, AfterContentInit {
    @ContentChildren(NestedDirective) nestedActions!: QueryList<NestedDirective>;

    @Input() observationType?: GenericType;
    @Input() shouldShowStateTag: boolean = true;
    @Input() set comment(value: EdlComment | undefined) {
        this._comment = value;

        this.sanitizedCommentText = value?.comment ?
            this.sanitized.bypassSecurityTrustHtml(value?.comment) :
            value?.comment;
    }

    get comment() {
        return this._comment;
    }

    private _comment: EdlComment | undefined;
    sanitizedCommentText: SafeHtml | undefined;

    historicLabel: string = DEFAULT_HISTORICAL_LABEL;
    filteredActions?: FilteredNested;

    PermissionTypes = PermissionTypes;
    CommentTags = CommentTags;

    constructor(
        private sanitized: DomSanitizer
    ) { }

    ngOnInit(): void {
        const commentObservationType = ObservationTypes.GetObservationType(this.comment?.evalType);
        this.historicLabel = (this.observationType?.Type !== this.comment?.evalType && commentObservationType?.Name) ?
            this.overrideHistoricLabel(commentObservationType) :
            DEFAULT_HISTORICAL_LABEL;
    }

    ngOnDestroy(): void {
        this.filteredActions?.complete();
    }

    ngAfterContentInit(): void {
        this.filteredActions = new FilteredNested(this.nestedActions);
    }

    private overrideHistoricLabel(commentObservationType: any) {
        if (commentObservationType.Type == ObservationTypes.Formal.Type) {
            return "Evidence";
        }
        return commentObservationType?.Name
    }


    commentState(comment: EdlComment): string {
        switch (comment.commentState) {
            case CommentState.PUBLISHED: return "Published";
            default: return "Draft";
        }
    }

    getCommentClass(comment: EdlComment): string {
        return this.commentState(comment).replace(/\s/g, "").replace(/\//g, "").toLocaleLowerCase();
    }
}
